import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import ComponentCard from "../../../components/common/ComponentCard";
import Label from "../../../components/form/Label";
import Input from "../../../components/form/input/InputField";
import Select from "../../../components/form/Select";
import Button from "../../../components/ui/button/Button";
import Form from "../../../components/form/Form";

const apiUrl = process.env.REACT_APP_API_URL;

export default function UpdateHeading() {
  const navigate = useNavigate();
  const location = useLocation();
  const heading = location.state?.heading;

  const [formData, setFormData] = useState({
    name: "",
    orderlevel: "",
    status: "",
  });

  useEffect(() => {
    if (heading) {
      setFormData({
        name: heading.name,
        orderlevel: heading.orderlevel,
        status: heading.status === 1 ? "current" : "non-current",
      });
    }
  }, [heading]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem("token");
      const payload = {
        inspectiontaskheading_id: heading.inspectiontaskheading_id,
        name: formData.name,
        orderlevel: formData.orderlevel,
        status: formData.status,
      };
      const response = await fetch(`${apiUrl}/headings`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          token: token || "",
        },
        body: JSON.stringify(payload),
      });
			
      if (response.ok) {
        navigate("/headings");
      }
    } catch (err) {
      console.error("Error:", err);
			
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this heading?")) return;

    try {
      const token = localStorage.getItem("token");

      const response = await fetch(
        `${apiUrl}/headings/${heading.inspectiontaskheading_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            token: token || "",
          },
        }
      );

      if (response.ok) {
        navigate("/headings");
      }
    } catch (err) {
      console.error("Delete Error:", err);
    }
  };

  return (
    <ComponentCard title="Update Heading">
      <Form onSubmit={handleSubmit}>
        <div className="grid gap-6">
          <div>
            <Label>Heading Name</Label>
            <Input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label>Display Order</Label>
            <Input
              type="text"
              name="orderlevel"
              value={formData.orderlevel}
              onChange={handleChange}
            />
          </div>
          <div>
            <Label>Record Status</Label>
            <Select
              options={[
                { value: "current", label: "Current" },
                { value: "non-current", label: "Non-Current" },
              ]}
              value={formData.status}
              onChange={(val: string) =>
                setFormData({ ...formData, status: val })
              }
              className="mt-2 bg-gray-50 dark:bg-gray-800"
            />
          </div>
          <div className="flex gap-3">
            <Button size="sm" type="submit">
              Update
            </Button>
            <Button
              size="sm"
              variant="outline"
              onClick={() => navigate("/headings")}
            >
              Cancel
            </Button>
            <button className="px-4 py-3 text-sm font-medium text-white rounded-lg bg-error-800 shadow-theme-xs hover:bg-error-600" onClick={handleDelete}>
							Delete
						</button>
          </div>
        </div>
      </Form>
    </ComponentCard>
  );
}
